"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdHidingData = exports.AdHidingData_AdHidingReason = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
/** In app presented ad hiding reasons */
var AdHidingData_AdHidingReason;
(function (AdHidingData_AdHidingReason) {
    /** AD_HIDING_REASON_UNSET - reserved for any unknown reasons it may have */
    AdHidingData_AdHidingReason[AdHidingData_AdHidingReason["AD_HIDING_REASON_UNSET"] = 0] = "AD_HIDING_REASON_UNSET";
    /** FREQUENCY_CAP_TOO_HIGH - ad showing frequency is too high */
    AdHidingData_AdHidingReason[AdHidingData_AdHidingReason["FREQUENCY_CAP_TOO_HIGH"] = 1] = "FREQUENCY_CAP_TOO_HIGH";
    /** IRRELEVANT_GENERAL - ad is irrelevant */
    AdHidingData_AdHidingReason[AdHidingData_AdHidingReason["IRRELEVANT_GENERAL"] = 2] = "IRRELEVANT_GENERAL";
    /** OFFENSIVE_GENERAL - ad is offensive */
    AdHidingData_AdHidingReason[AdHidingData_AdHidingReason["OFFENSIVE_GENERAL"] = 3] = "OFFENSIVE_GENERAL";
    /** ALREADY_BOUGHT_ITEM - user already bought product in ad */
    AdHidingData_AdHidingReason[AdHidingData_AdHidingReason["ALREADY_BOUGHT_ITEM"] = 4] = "ALREADY_BOUGHT_ITEM";
    /** ALREADY_INSTALLED_APP - user already installed app in ad */
    AdHidingData_AdHidingReason[AdHidingData_AdHidingReason["ALREADY_INSTALLED_APP"] = 5] = "ALREADY_INSTALLED_APP";
    AdHidingData_AdHidingReason[AdHidingData_AdHidingReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AdHidingData_AdHidingReason = exports.AdHidingData_AdHidingReason || (exports.AdHidingData_AdHidingReason = {}));
function createBaseAdHidingData() {
    return { adHidden: undefined, reason: 0 };
}
exports.AdHidingData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.adHidden !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.adHidden }, writer.uint32(10).fork()).ldelim();
        }
        if (message.reason !== 0) {
            writer.uint32(16).int32(message.reason);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdHidingData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.adHidden = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.reason = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdHidingData();
        message.adHidden = object.adHidden ?? undefined;
        message.reason = object.reason ?? 0;
        return message;
    },
};
//# sourceMappingURL=ad_hiding_data.js.map